<template>
  <News code="laws_regulations" />
</template>
<script>
import News from "./news.vue";

export default {
  name: "About",
  components: {
    News,
  },
  data() {
    return {
      pageData: {},
    };
  },
  created() {},
  methods: {},
};
</script>
